import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./styles/main.scss";
// @ts-ignore
import "bootstrap/dist/js/bootstrap.js";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
